/** Shared formatting + threshold colors for the marketing dashboard (spec TRE-1454). */

const plnFormatter = new Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN", maximumFractionDigits: 0 });
const numberFormatter = new Intl.NumberFormat("pl-PL", { maximumFractionDigits: 2 });
const percentFormatter = new Intl.NumberFormat("pl-PL", { maximumFractionDigits: 0 });

export const toFiniteNumber = (value: unknown): number | null => {
  if (value == null || (typeof value === "string" && !value.trim())) {
    return null;
  }

  if (typeof value !== "number" && typeof value !== "string") {
    return null;
  }

  const numericValue = typeof value === "number" ? value : Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const formatPln = (value: unknown): string => {
  const numericValue = toFiniteNumber(value);
  return numericValue == null ? "—" : plnFormatter.format(numericValue);
};

export const formatNumber = (value: unknown): string => {
  const numericValue = toFiniteNumber(value);
  return numericValue == null ? "—" : numberFormatter.format(numericValue);
};

export const formatPercent = (value: unknown): string => {
  const numericValue = toFiniteNumber(value);
  return numericValue == null ? "—" : `${percentFormatter.format(numericValue)}%`;
};

/** Tailwind cell classes for the three color-coded thresholds. */
export const SR_GREEN = 55;
export const SR_YELLOW = 40;
export const ROAS_GREEN = 3;
export const ROAS_YELLOW = 1;
export const CAC_THRESHOLD = 650;

const GREEN = "text-emerald-700 bg-emerald-50";
const YELLOW = "text-amber-700 bg-amber-50";
const RED = "text-red-700 bg-red-50";

export const srColor = (value: unknown): string => {
  const sr = toFiniteNumber(value);
  if (sr == null) return "";
  if (sr >= SR_GREEN) return GREEN;
  if (sr >= SR_YELLOW) return YELLOW;
  return RED;
};

export const roasColor = (value: unknown): string => {
  const roas = toFiniteNumber(value);
  if (roas == null) return "";
  if (roas >= ROAS_GREEN) return GREEN;
  if (roas >= ROAS_YELLOW) return YELLOW;
  return RED;
};

export const cacColor = (value: unknown): string => {
  const cac = toFiniteNumber(value);
  if (cac == null) return "";
  return cac <= CAC_THRESHOLD ? GREEN : RED;
};
